module.exports = __webpack_public_path__ + "media/country_flags/bh-326075db.png";